export type ScreenName = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

export type Screens = {
  [name in ScreenName]: number;
};

export const screens: Screens = {
  xs: 375,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  xxl: 1536,
};
